//引入我们的vue和vuex。
import Vue from 'vue'
import Vuex from 'vuex'
//使用我们vuex，引入之后用Vue.use进行引用
Vue.use(Vuex);

const state = {
  cityList: [],//城市列表
  demo: 111,
  token: '',
  Name: '',
  UserID: 0,
  SchoolID:'',
  TeacherID: '',
  content: 0,
  goChapterID: 0,
  planClasslist: [],
  tabList: [],
  menu: [],
  index: false,
   //选中的三级教材.
   lastTeachingMaterial: null,
   lastTeachingMaterialLabels: null,

  // 精品课,是否添加状态
  qualityClassState:{
    added:{
      value:1,
      dis:"已添加"
    },
    notAdded:{
      value:2,
      dis:"未添加"
    }
  }
};

// getters 只会依赖 state 中的成员去更新
const getters = {
  userName: (state) => state.user
};

const actions = {};

const mutations = {   
  /**
     * 设置城市数据（city的复数形式为啥是cities？看着就不好，建议改为citys）
     *
     * @param {Object} state 状态对象
     * @param {Array} cities 城市数组
     */
  setCityList(state, data) {
    state.cityList = data;
  },
  //五级初始赋值.
  upLastTeachingMaterial(state, values) {
    state.lastTeachingMaterial = values;
  },
  upLastTeachingMaterialLabels(state, labels) {
    state.lastTeachingMaterialLabels = labels;
  },
  changeToken: (store, token) => {
    store.demo = token;
  },
  setPlanClasslist: (store, planClasslist) => {
    store.planClasslist = planClasslist;
  }
};

export default new Vuex.Store({
  actions,
  mutations,
  state,
  getters
})



// WEBPACK FOOTER //
// ./src/store/store.js